import * as React from 'react';
import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { useSelector } from 'react-redux';
import { Layout } from '../../components/Layout';
import { MORTGAGE_MINI_CALCULATOR_MF_NAME } from '../../constants/microfrontends';
import { useIsRealtor } from '../../hooks/useIsRealtor';
import { getNewbuildingOfferType } from '../../selectors/newbuilding';
import { EOfferTypes } from '../../types/offers';
import { useApplicationContext } from '../../utils/withApplicationContext';

export const MortgageMiniCalculatorWidget = () => {
  const { config } = useApplicationContext();
  const isRealtor = useIsRealtor();
  const newbuildingOfferType = useSelector(getNewbuildingOfferType);
  const manifest = config.get<IMicrofrontendManifest>(`microfrontendManifests.${MORTGAGE_MINI_CALCULATOR_MF_NAME}`);
  const mortgageMiniCalculatorEnabled = config.get<boolean>('Newbuilding.MortgageMiniCalculator.Enabled');

  if (!manifest || !mortgageMiniCalculatorEnabled || isRealtor) {
    return null;
  }

  const objectType = newbuildingOfferType === EOfferTypes.ApartmentOnly ? 'apartments' : 'flat';

  return (
    <Layout>
      <Microfrontend
        name={manifest.microfrontendName}
        image={manifest.imageVersion}
        runtime={manifest.runtimeName}
        parameters={{
          defaultFormState: { objectType, realEstateType: 'newBuilding' },
        }}
      />
    </Layout>
  );
};
